import { LocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseModel } from '../models/base.model';
import { EnumRecursoPerfil } from '../models/enum/recurso-perfil.enum';
import { IPerfilUsuarioModel } from '../models/perfil-usuario.model';
import { IUsuarioEstadoModel } from '../models/usuario-estado.model';
import { BaseService } from './base.service';
import { IEnumModel } from '../models/enum.model';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthService extends BaseService {
  public usuario: IPerfilUsuarioModel;

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  // public async obterPerfilUsuario(): Promise<IBaseModel<IPerfilUsuarioModel>> {
  //   if (this.usuario) {
  //     return Promise.resolve({ sucesso: true, dados: this.usuario } as IBaseModel<IPerfilUsuarioModel>);
  //   } else {
  //     try {
  //       const res = await this.httpClient
  //         .get<IBaseModel<IPerfilUsuarioModel>>(`${this.apiBaseUrl}/usuario/perfil`)
  //         .toPromise();
  //       this.usuario = res.dados;
  //       return res;
  //     }
  //     catch (err) {
  //       delete (this.usuario);
  //       throw (err);
  //     }
  //   }
  // }

  public obterEstado(): Promise<IBaseModel<IUsuarioEstadoModel>> {
    return this.httpClient
      .get<IBaseModel<IUsuarioEstadoModel>>(`${this.apiBaseUrl}/usuario/estado`)
      .toPromise();
  }

  public logout(): void {
    window.location.replace('./conta/logout');
  }

  public login(): void {
    window.location.replace('./conta/login?returnUrl=' + window.location);
  }

  // public possuiPermissao(recurso: string, acao: string) {
  //   if (EnumRecursoPerfil.Aberto == recurso)
  //     return true;
  //   var recursos = this.usuario && this.usuario.permissoesRecursos && this.usuario.permissoesRecursos.find(d => d.recurso.toUpperCase() == recurso.toUpperCase());
  //   return recursos != undefined && recursos.acoes.some(d => d.toUpperCase() == acao.toUpperCase());
  // }

  public possuiPerfis(perfis?: string[]) {
    if (!perfis || !this.usuario?.perfis) {
      return false;
    }
    return perfis.some(p => this.usuario.perfis.indexOf(p) >= 0);
  }

  public possuiPermissaoRecurso(recurso: string, acao: string) {
    return false;
  }

  public async obterPerfisSimplificado(): Promise<IBaseModel<IEnumModel[]>> {

    try {
      const res = await this.httpClient
        .get<IBaseModel<IEnumModel[]>>(`${this.apiBaseUrl}/usuario/obterPerfisSimplificado`)
        .toPromise();
      return res;
    }
    catch (err) {
      throw (err);
    }

  }

  /*
  DATA: 17/07/2025
  DESCRIÇÃO: Mudança temporária para testes locais e até a inclusão da permissão para o módulo de Gestão de Riscos - Processos.
  */
  public async obterPerfilUsuario(): Promise<IBaseModel<IPerfilUsuarioModel>> {
    if (this.usuario) {
      return Promise.resolve({
        sucesso: true,
        dados: this.usuario
      } as IBaseModel<IPerfilUsuarioModel>);
    } else {
      try {
        const res = await this.httpClient
          .get<IBaseModel<IPerfilUsuarioModel>>(`${this.apiBaseUrl}/usuario/perfil`)
          .toPromise();

        // 🔧 MOCK TEMPORÁRIO PARA TESTES LOCAIS - REMOVER EM PRODUÇÃO
        // const recursoMock = {
        //   recurso: 'Gestão de Riscos - Processos',
        //   acoes: ['Inserir']
        // };

        // Mock permissoes
        // res.dados.permissoes = res.dados.permissoes ?? [];
        // const jaPossuiPermissoes = res.dados.permissoes.some(p =>
        //   p.recurso === recursoMock.recurso
        // );
        // if (!jaPossuiPermissoes) {
        //   res.dados.permissoes.push(recursoMock);
        // }

        // // Mock permissoesRecursos
        // res.dados.permissoesRecursos = res.dados.permissoesRecursos ?? [];
        // const jaPossuiPermissoesRecursos = res.dados.permissoesRecursos.some(p =>
        //   p.recurso === recursoMock.recurso
        // );
        // if (!jaPossuiPermissoesRecursos) {
        //   res.dados.permissoesRecursos.push(recursoMock);
        // }

        // Atualiza o usuário
        this.usuario = res.dados;

        return res;
      }
      catch (err) {
        delete this.usuario;
        throw err;
      }
    }
  }

  public possuiPermissao(recurso: string, acao: string): boolean {
    // Libera rotas públicas
    if (EnumRecursoPerfil.Aberto === recurso) return true;

    // Pega as permissões de onde estiver definido (preferência para permissoesRecursos)
    const permissoes = this.usuario?.permissoesRecursos ?? this.usuario?.permissoes ?? [];

    if (!permissoes || permissoes.length === 0) {
      return false;
    }

    // Normaliza os nomes para comparação case-insensitive e sem acento
    // (ex.: 'Orgãos...' x 'Órgãos...' do backend não podem quebrar o acesso)
    const normalizar = (s?: string) =>
      s?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
    const recursoNormalizado = normalizar(recurso);
    const acaoNormalizada = normalizar(acao);

    // Busca o recurso na lista de permissões
    const recursoEncontrado = permissoes.find(p =>
      normalizar(p.recurso) === recursoNormalizado
    );

    // Verifica se o recurso tem a ação necessária
    return recursoEncontrado?.acoes?.some(a =>
      normalizar(a) === acaoNormalizada
    ) ?? false;
  }

  public obterPerfisUsuarioAcessoCidadao(): Observable<IBaseModel<any>> {
    return this.httpClient.get<IBaseModel<any>>(`${this.apiBaseUrl}/usuario/obterPerfisUsuarioAcessoCidadaoToJson`);
  }

}
